<div class="{{overlayClassName}}">
</div>
<div class="{{spinnerOverlayClassName}}">
    <mat-spinner></mat-spinner>
</div>
